import { Location } from "@angular/common";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalInterceptor, MsalInterceptorConfiguration, MsalService, ProtectedResourceScopes } from "@azure/msal-angular";
import { InteractionType } from "@azure/msal-browser";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { appCommonConstants } from "../app.constants";
import { appAuthConstants } from "../modules/auth/auth.constants";
import { AppAuthDataService } from "../services/authData.service";

// Ref: https://stackoverflow.com/a/75920783
@Injectable()
export class MsalSkipInterceptor extends MsalInterceptor implements HttpInterceptor {
  constructor(
    location: Location,
    msalService: MsalService,
    private authData: AppAuthDataService) {
    super(MSALInterceptorConfigFactory(), msalService, location, (MsalInterceptor as any).msalBroadcastService);
  }

  override intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!environment.azureLogin?.enabled || !this.authData.getLoginData()?.azureLogin) {
      return next.handle(request);
    }
    return super.intercept(request, next);
  }
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  let clientId = environment?.azureLogin?.clientId ?? "";
  const protectedResourceMap = environment.azureLogin?.scopes ?? new Map<string, Array<string | ProtectedResourceScopes>>();
  protectedResourceMap.set(appCommonConstants.url.getDefaultDate, []);
  protectedResourceMap.set(appCommonConstants.url.getEnvironments, []);
  protectedResourceMap.set(appAuthConstants.url.login, []);
  protectedResourceMap.set(appAuthConstants.url.verify, []);  // L'intercept per questa chiamata è effettuata dentro AppHttpInterceptor
  protectedResourceMap.set("assets/i18n/", []);
  protectedResourceMap.set(environment.appSettings.apiBaseAddress, [`api://${clientId}/WebApi.Execute`]);

  return {
    interactionType: environment.azureLogin?.interactionType ?? InteractionType.Redirect,
    protectedResourceMap
  };
}
